import React from "react";
import {
  PieChart,
  Pie,
  Cell,
  Tooltip,
  Legend as RechartsLegend,
  ResponsiveContainer
} from "recharts";
import { Grid } from "@material-ui/core";
import useStyles from "./styles";

const Chart = ({ data, innerRadius, outerRadius, colors }) => {
  const classes = useStyles();

  const totalSpentDonation = data.reduce(
    (acc, entry) => acc + entry.SpentDonation,
    0
  );

  const formatCurrency = (value) => {
    if (typeof value !== "number" || isNaN(value)) return "";
    return value >= 1000 ? `$${(value / 1000).toFixed(1)}k` : `$${value}`;
  };

  return (
    <Grid container>
      <Grid item xs={12}>
        <ResponsiveContainer width="100%" height={420}>
          <PieChart className={classes.PaiChart}>
            <Pie
              data={data}
              cx="60%"
              cy="50%"
              innerRadius={innerRadius}
              outerRadius={outerRadius}
              paddingAngle={1}
              dataKey="SpentDonation"
              nameKey="name"   // IMPORTANT for legend
            >
              {data.map((entry, index) => (
                <Cell
                  key={`cell-${index}`}
                  fill={colors[index % colors.length]}
                />
              ))}
            </Pie>

            <Tooltip
              formatter={(value) => `$${value}`}
            />

            <RechartsLegend
              align="right"
              verticalAlign="middle"
              layout="vertical"
            />

            <text
              x="60%"
              y="50%"
              textAnchor="middle"
              fontSize="20"
              fill="#000"
              className={classes.Balance}
            >
              <tspan dy="0" className="BalancePrice">
                {formatCurrency(totalSpentDonation)}
              </tspan>
              <tspan x="60%" dy="1.7em" className="BalanceText">
                Total Awarded Grant
              </tspan>
            </text>
          </PieChart>
        </ResponsiveContainer>
      </Grid>
    </Grid>
  );
};

export default Chart;
